import { useDispatch, useSelector } from 'react-redux';
import { createEpicMiddleware } from 'redux-observable';
import type { Action, Middleware } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';

import rootEpic from '../../../rootEpic';
import rootReducer from '../../../rootReducer';

export type RootState = ReturnType<typeof rootReducer>;

const epicMiddleware = createEpicMiddleware<Action, Action, RootState>();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(epicMiddleware as Middleware),
  devTools: true,
});

epicMiddleware.run(rootEpic);

export type StoreType = typeof store;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export default store;
